import { render, staticRenderFns } from "./ApiRootCard.vue?vue&type=template&id=2525cda2&scoped=true"
import script from "./ApiRootCard.vue?vue&type=script&lang=js"
export * from "./ApiRootCard.vue?vue&type=script&lang=js"
import style0 from "./ApiRootCard.vue?vue&type=style&index=0&id=2525cda2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2525cda2",
  null
  
)

export default component.exports